import app from './app'
import mapOverlays from './mapOverlays'

const reducers = {
  app,
  mapOverlays,
}

export default reducers
